"use strict";
import React from "react";
import PropTypes from "prop-types";
import Moment from "moment-timezone";
import Toggleable from "../components/hoc/toggleable";
import keyState from "./KeyState";
import environmentSelector from "./EnvironmentSelector";
import { KEY } from "./constants";

const SNAPSHOT_KEY = 'FLEX_STATE_SNAPSHOT';

let fixedPanelStyle = {
    position: 'fixed',
    top: '108px',
    left: '20px',
    boxShadow: '1px 1px 10px 0px',
    width: '250px',
    overflowY: 'auto',
    zIndex: 9999,
    maxHeight: '600px'
};

const actionable = {
    cursor: 'pointer',
    userSelect: 'none',
    padding: '10px 15px'
};

const panelAdditions = {
    marginBottom: '0px'
};

module.exports = (flex = window.flex) => {

    const EnvironmentSelector = environmentSelector(flex);
    const KeyState = keyState(flex);

    class DevPanel extends React.PureComponent {
        constructor(props, context) {
            super(props, context);

            this.state = {
                visible: sessionStorage.getItem('devPanelVisible'),
                keyState: new KeyState(),
                snapshotLabel: '',
                snapshots: JSON.parse(sessionStorage.getItem(SNAPSHOT_KEY) || '[]')
            };
        }

        componentDidMount() {
            this.state.keyState.subscribe(() => {
                let visible = !this.state.visible;
                sessionStorage.setItem('devPanelVisible', visible);
                this.setState({ visible });
            }, [KEY.ALT, KEY.P]);
        }

        updateValue = event => {
            let updates = {};
            updates[event.target.name] = event.target.value;
            this.setState(updates);
        };

        rewindAppState = time => {
            let snapshot = this.state.snapshots.find(s => s.time === time);
            if (!snapshot) {
                return;
            }
            flex.setStore(snapshot.state);
            console.log(`..Rewound app state to ${Moment(snapshot.time).format('ddd HH:mm')}`)
        };

        snapshotAppState = () => {
            let snapshot = {
                time: Date.now(),
                label: this.state.snapshotLabel,
                state: flex.getStore()
            };
            let snapshots = this.state.snapshots.slice();
            snapshots.push(snapshot);
            sessionStorage.setItem(SNAPSHOT_KEY, JSON.stringify(snapshots));
            this.setState({ snapshots, snapshotLabel: '' });
        };

        removeSnapshot = time => {
            let snapshots = this.state.snapshots.slice(),
                index = snapshots.findIndex(s => s.time === time);

            if (index !== -1) {
                snapshots.splice(index, 1);
                this.setState({ snapshots });
                sessionStorage.setItem(SNAPSHOT_KEY, JSON.stringify(snapshots));
            }
        };

        render() {
            if (!this.state.visible) {
                return false;
            }

            const { ToggleTarget, ToggleArea } = this.props;
            let style = Object.assign({}, fixedPanelStyle);

            return (
                <div style={style}>
                    <div className="panel panel-default action-block" style={panelAdditions}>
                        <ToggleTarget className="panel-heading" style={actionable}>
                            <h4 className="text-center">Dev Panel</h4>
                        </ToggleTarget>
                        <ToggleArea>
                            <div className="">
                                <div className="panel-body">
                                    <EnvironmentSelector environment={this.props.environment} />
                                    <hr />
                                    <input
                                        name="snapshotLabel"
                                        value={this.state.snapshotLabel}
                                        placeholder="snapshot label..."
                                        onChange={this.updateValue}
                                    />
                                    <button className="btn btn-primary" onClick={this.snapshotAppState}>
                                        Snapshot AppState
                                    </button>
                                    <h4>Snapshots</h4>
                                    {
                                        this.state.snapshots.map(snapshot => <div key={snapshot.time} className="form-group">
                                            {!snapshot.label || !snapshot.label.length ?
                                                <div>
                                                    <span className="label label-warning" style={{ display: 'block' }}>
                                                        NO LABEL
                                                    </span>
                                                </div>
                                                :
                                                <div>
                                                    <span className="label label-info" style={{ display: 'block' }}>
                                                        {snapshot.label}
                                                    </span>
                                                </div>
                                            }
                                            <div className="input-group">
                                                <span className="input-group-btn">
                                                    <input
                                                        type="button"
                                                        value="Clear"
                                                        className="btn-inline btn-danger"
                                                        onClick={this.removeSnapshot.bind(this, snapshot.time)} />
                                                </span>
                                                <input value={Moment(snapshot.time).format('ddd HH:mm')} disabled />
                                                <span className="input-group-btn">
                                                    <input
                                                        type="button"
                                                        value="Apply"
                                                        className="btn-inline btn-primary"
                                                        onClick={this.rewindAppState.bind(this, snapshot.time)} />
                                                </span>
                                            </div>
                                        </div>)
                                    }
                                </div>
                            </div>
                        </ToggleArea>
                    </div>
                </div>
            );
        }
    }

    DevPanel.propTypes = {
        environment: PropTypes.string.isRequired
    };

    DevPanel.defaultProps = {
        //myDefaultProp: 'abc'
    };

    return Toggleable(DevPanel, true);
};